import React, { useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { navigateToPlan } from '@/common/utils/wellnessPlan';
import { OverviewStyles, OverviewCard } from '../Info';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import { SendWaiverLinkModal } from '@/views/Pages/Appointments/EventView/SendLinkModals/SendWaiverLinkModal';

const ClientStatus = props => {
  const { customerData } = props;
  const classes = OverviewStyles();

  const customerId = customerData?.customer?.id;
  const [isSendLinkOpen, setIsSendLinkOpen] = useState(false);

  return (
    <OverviewCard>
      {isSendLinkOpen && (
        <SendWaiverLinkModal
          onClose={() => setIsSendLinkOpen(false)}
          customer={customerData?.customer}
          title={'Send Signup/Waiver to ' + customerData?.customer?.firstName}
          dataSource={[{ what: 'signup' }]}
        />
      )}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Status
            </Typography>
            {customerData?.isMembershipDelinquent && (
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <ErrorIcon
                    className={classes.icon}
                    style={{ color: 'red' }}
                  />
                </Grid>
                <Grid item>
                  <Typography className={classes.bodyText} variant="body2">
                    Autopay Failed
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid container alignItems="center" spacing={1}>
              {customerData?.status?.coreWaiver?.status === 'SIGNED' ? (
                <>
                  <Grid item>
                    <CheckCircleIcon
                      className={classes.icon}
                      style={{ color: 'green' }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.bodyText} variant="body2">
                      Waivers Signed
                    </Typography>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item>
                    <ErrorIcon
                      className={classes.icon}
                      style={{ color: 'red', height: 20 }}
                    />
                  </Grid>
                  <Grid item>
                    <a onClick={() => setIsSendLinkOpen(true)} href={void 0}>
                      <Typography
                        gutterBottom
                        style={{ display: 'inline', cursor: 'pointer' }}
                        className={classes.bodyText}
                        variant="body2"
                      >
                        {customerData?.status?.coreWaiver?.status === 'EXPIRED'
                          ? 'Waiver Expired'
                          : 'Waiver Missing'}
                      </Typography>
                      <AddToHomeScreenIcon
                        className={classes.missingIcon}
                        fontSize={'small'}
                      />
                    </a>
                  </Grid>
                </>
              )}
            </Grid>
            {customerData?.status?.membershipAgreement?.status !==
              'NO_MEMBERSHIP' &&
              customerData?.status?.membershipAgreement?.status !==
                'NO_ACTIVE_MEMBERSHIP' && (
                <Grid container alignItems="center" spacing={1}>
                  {customerData?.status?.membershipAgreement?.status ===
                  'SIGNED' ? (
                    <>
                      <Grid item>
                        <CheckCircleIcon
                          className={classes.icon}
                          style={{ color: 'green', height: 20 }}
                        />
                      </Grid>
                      <Grid item>
                        <Typography
                          className={classes.bodyText}
                          variant="body2"
                        >
                          Membership Agreement Signed
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item style={{ whiteSpace: 'nowrap' }}>
                        <ErrorIcon
                          className={classes.icon}
                          style={{ color: 'red', height: 20 }}
                        />
                        <Typography
                          className={classes.bodyText}
                          style={{ display: 'inline', marginLeft: 6 }}
                          variant="body2"
                        >
                          Unsigned Membership Agreement
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              )}
            {customerData?.status?.safetyAlert && (
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <ErrorIcon
                    className={classes.icon}
                    style={{ color: 'red', height: 20 }}
                  />
                </Grid>
                <Grid item>
                  <Typography className={classes.bodyText} variant="body2">
                    Safety Alert
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Focus Area
            </Typography>
            {customerData?.activeWellnessPlan ? (
              <>
                <Typography className={classes.bodyText} variant="body2">
                  {customerData?.activeWellnessPlan?.introVerbiage}
                </Typography>
                <Typography
                  className={classes.wellnessPlanLink}
                  variant="body2"
                  onClick={() =>
                    navigateToPlan(
                      customerId,
                      customerData?.activeWellnessPlan?.questionnaireSlug,
                      customerData?.activeWellnessPlan?.session
                    )
                  }
                >
                  Wellness Plan
                </Typography>
              </>
            ) : (
              <Typography className={classes.bodyText} variant="body2">
                --
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Contraindicators
            </Typography>
            {customerData?.contraindications &&
            customerData.contraindications.length > 0 ? (
              customerData.contraindications.map((contraindication, index) => (
                <Typography
                  key={index}
                  className={classes.bodyText}
                  variant={'body2'}
                >
                  • {contraindication.description}
                </Typography>
              ))
            ) : (
              <Typography className={classes.bodyText} variant={'body2'}>
                {' '}
                --
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default ClientStatus;
